import { render, staticRenderFns } from "./BillingStatusBadge.vue?vue&type=template&id=436b2eec&"
import script from "./BillingStatusBadge.vue?vue&type=script&lang=js&"
export * from "./BillingStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports